import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f14058b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image*", -1))
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "card w-75 shadow-xl" }
const _hoisted_12 = { class: "card-body items-center text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Icone 3D*", -1))
const _hoisted_14 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_15 = { class: "card w-full shadow-xl" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = {
  key: 1,
  class: "text-sm text-gray-500 mt-1 mb-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "12, 34, 56", -1))
const _hoisted_20 = { class: "card-actions" }
const _hoisted_21 = { key: 0 }

import {ref, computed, onMounted} from 'vue';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import UploadImage from "@/components/forms/UploadImage.vue";
import {IMiddleMenu} from "@/models/homepage/IMiddleMenu";
import { useRoute, useRouter } from 'vue-router'

const submitBtnLabel = 'Ajouter';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddMiddleMenu',
  setup(__props) {

const title = ref<string>("Ajouter une référence");
const router = useRouter();
const route = useRoute();
const loading = ref<boolean>(false);
const form = ref<IMiddleMenu>({
    image: null,
    icon3d: null
});
const configMoney = ref<{ locale?: string }>({})

const allowedTypes = ['region']

const type = computed(() => {
    const current = route.params.type as string | undefined
    return allowedTypes.includes(current ?? '') ? current : null
})

if (route.params.type && !allowedTypes.includes(route.params.type as string)) {
    router.replace({ name: 'addMiddleMenu' }) 
}

onMounted(async () => {
    try {
        const { data } = await ApiService.get('/config-money')
        configMoney.value = data.data
    } catch (e) {
        console.error('Erreur récupération config-money', e)
    }
})

const shouldShowAdditionalInfo = computed(() => {
    const value = (configMoney.value?.locale ?? 'fr_FR').toLowerCase()
    return !value.includes('en') ?? true
})

const onSubmit = async (formData) => {
    try {
        const payload = {
            position: parseInt(formData.position),
            title: formData.title,
            image: form.value.image?.uuid ?`/api/images/${form.value.image.uuid}` : null,
            icon3d: form.value.icon3d?.uuid ? `/api/images/${form.value.icon3d.uuid}` : null,
            blockType: type.value && type.value === "region" ? "region" : "current_offer",
            displayVersion: type.value && type.value === "region" ? "new" : "both",
            additionalInfo: formData.additionalInfo,
            reference: formData.reference
        }
        swal.confirm(`le champ "Idenfiant: ${formData.reference ?? ''}" ne pourra plus être modifié, êtes sûr(e) de la valeur renseignée ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && addMiddleMenu(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const addMiddleMenu = (data) => {
    ApiService.post('middle_menus', data)
        .then(() => {
            loading.value = false;
            swal.info("Ajout avec succès")
                .then((result) => {
                    if (result.isConfirmed) {
                        if (type.value && type.value == "region") {
                            router.push({
                                name: "regionList"
                            });
                        } else {
                            router.push({
                                name: "middleMenuList"
                            });
                        }
                    }
                });
        })
        .catch(() => {
            swal.error("Une erreur est survenue lors de la modification");
        });
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'ajout ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            if (type.value && type.value == "region") {
                router.push({
                    name: "regionList"
                });
            } else {
                router.push({
                    name: "middleMenuList"
                });
            }
        }
    });
}

const onImageUpload = (image) => {
    image ? form.value.image = image : form.value.image = null;
}

const onImageIconUpload = (image) => {
    image ? form.value.icon3d = image : form.value.icon3d = null;
}

const onImageRemoved = () => {
    form.value.image = null;
}

const onImageIconRemoved = () => {
    form.value.icon3d = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(UploadImage, {
                  "image-preview-url": getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageRemoved,
                  onImageUploaded: onImageUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(UploadImage, {
                  "image-preview-url": getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageIconRemoved,
                  onImageUploaded: onImageIconUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "title",
                      label: "Titre *",
                      validation: "required|contains_alpha|matches:/^[^/]*$/",
                      "validation-messages": {
                    required: 'Ce champ est obligatoire.',
                    contains_alpha: 'Ce champ doit contenir des lettres..',
                    matches: 'Ce champ ne peut contenir de “/”.'
                 }
                    }, null, 8, ["validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      name: "position",
                      label: "Position *",
                      validation: "required|min:1",
                      "validation-messages": {
                    required: 'Ce champ est obligatoire.',
                    min: 'Ce champ doit être un nombre décimal superieur à 0',
                }
                    }, null, 8, ["validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "reference",
                      label: "Identifiant *",
                      validation: "required",
                      "validation-messages": {
                            required: 'Ce champ est obligatoire.'
                         }
                    }, null, 8, ["validation-messages"]),
                    (type.value == 'region' && shouldShowAdditionalInfo.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "text",
                          name: "additionalInfo",
                          label: "Références numériques *",
                          validation: "required",
                          "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                       }
                        }, null, 8, ["validation-messages"]))
                      : _createCommentVNode("", true),
                    (type.value == 'region' && shouldShowAdditionalInfo.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createTextVNode(" Format attendu : nombres à 2 chiffres, séparés par des virgules. Exemple : "),
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})